export default "__VITE_ASSET__C$vf1EJe__"